import creatureDefinitions from './simulator/creatureDefinitions.js';
import {simulate} from './simulator/walkSimulator.js';
import {runEa} from './ea.js';

/**
 * @typedef {Object} Individual
 * @property {number[]} genes
 * @property {number} fitness
 */
export default function evolveWalkers(options) {
    const creatureType = options.creatureType;
    const populationSize = options.populationSize;
    const mutationRate = options.mutationRate;
    const crossoverRate = options.crossoverRate;

    const numberOfGenes = creatureDefinitions[creatureType].edges.length;

    /**
     * @returns {Individual[]}
     */
    function generatePopulationFunction() {
        /**
         * @type {Individual[]}
         */
        const population = [];
        for (let i = 0; i < populationSize; i++) {
            const genes = [];
            for (let j = 0; j < numberOfGenes; j++) {
                genes.push(Math.random());
            }
            population.push({
                genes: genes,
                fitness: 0
            });
        }
        return population;
    }

    /**
     * @param population {Individual[]}
     */
    async function fitnessFunction(population) {
        const results = await simulate(creatureType, population);

        results.forEach((result, i) => {
            let max = 0;
            result.forEach(r => {
                if (r > max) {
                    max = r;
                }
            });
            population[i].fitness = max;
        });
        // results[i] belongs to population[i]
    }

    /**
     * @param population {Individual[]}
     * @returns {Individual[]}
     */
    function parentSelectionFunction(population) {
        let parents = [];

        for (let i = 0; i < populationSize; i++) {

            let index1 = Math.floor(Math.random() * population.length);
            let index2 = Math.floor(Math.random() * population.length);

            let f1 = population[index1].fitness;
            let f2 = population[index2].fitness;
            if (f1 >= f2) {
                parents.push(population[index1]);
            } else {
                parents.push(population[index2]);
            }

        }

        return parents;
    }

    /**
     * @param oldPopulation {Individual[]}
     * @param children {Individual[]}
     * @returns {Individual[]}
     */
    function adultSelectionFunction(oldPopulation, children) {
        var olds = oldPopulation.slice().sort((a, b) => a.fitness - b.fitness).reverse();
        return children.concat([olds[0], olds[1]]);


        return children;
    }

    /**
     * @param individual {Individual}
     */
    function mutateFunction(individual) {

        for (let i = 0; i < individual.genes.length; i++) {
            if (Math.random() <= mutationRate) {
                individual.genes[i] = Math.max(0, Math.min(1, individual.genes[i] + gauss()));
            }
        }

        /*if (Math.random() <= mutationRate) {
            const geneToMutate = Math.floor(Math.random() * individual.genes.length);
            const value = Math.max(0, Math.min(1, individual.genes[geneToMutate] + gauss()));

            individual.genes[geneToMutate] = value;
        }*/
    }

    function gauss() {
        return (Math.random() + Math.random() + Math.random()
            + Math.random() + Math.random() + Math.random() - 3) / 3;
    }

    /**
     *
     * @param parent1 {Individual}
     * @param parent2 {Individual}
     */
    function crossoverFunction(parent1, parent2) {
        const gene1 = parent1.genes;
        const gene2 = parent2.genes;
        if (Math.random() < crossoverRate) {
            const crossoverPoint = Math.floor(Math.random() * gene1.length);

            for (let i = 0; i < crossoverPoint; i++) {
                const value = gene1[i];
                gene1[i] = gene2[i];
                gene2[i] = value;
            }
        }
    }

    runEa({
        generatePopulation: generatePopulationFunction,
        fitness: fitnessFunction,
        adultSelection: adultSelectionFunction,
        parentSelection: parentSelectionFunction,
        mutate: mutateFunction,
        crossover: crossoverFunction
    });
}



//////////////////
// WEBPACK FOOTER
// ./js/walkerEaRunner.js
// module id = 154
// module chunks = 0